import { useState } from 'react';
import { Link } from 'react-router-dom';
import DB from '../data/mockData';

const TABS = ['All', 'NL Available', 'Gaps', 'Single Molecule', 'Combined'];

function maPill(ma) {
  if (ma === 'Marketed') return 'p-g';
  if (ma.includes('Exp') || ma === 'Pending' || ma === 'CBG Pending') return 'p-a';
  return 'p-n';
}

export default function Catalogue() {
  const [query, setQuery] = useState('');
  const [tab, setTab] = useState(0);

  let data = DB.products;
  if (query) {
    const q = query.toLowerCase();
    data = data.filter(p => p.name.toLowerCase().includes(q) || p.inn.toLowerCase().includes(q) || p.supplier.toLowerCase().includes(q));
  }
  if (tab === 1) data = data.filter(p => p.nl);
  if (tab === 2) data = data.filter(p => !p.nl);
  if (tab === 3) data = data.filter(p => p.type === 'Single');
  if (tab === 4) data = data.filter(p => p.type === 'Combined');

  const counts = [DB.products.length, DB.products.filter(p => p.nl).length, DB.products.filter(p => !p.nl).length, '', ''];

  return (
    <div className="content">
      {/* Alert bar */}
      <div className="d-flex gap-2 align-items-center flex-wrap">
        <div className="flex-grow-1 p-2 px-3 rounded-2" style={{ fontSize: 12, color: 'var(--amber)', background: 'var(--amber2)', border: '1px solid rgba(184,92,0,.2)' }}>
          ⚠ <strong>247 products</strong> need BD team validation (50% done · 80% required for full AI analysis)
        </div>
        <button className="btn btn-p btn-sm">+ Add Product</button>
        <Link to="/upload" className="btn btn-s btn-sm">↑ Upload List</Link>
        <button className="btn btn-s btn-sm">↓ Export CSV</button>
      </div>

      {/* Main card */}
      <div className="card">
        {/* Tabs */}
        <div className="d-flex border-bottom px-3 overflow-auto" style={{ background: 'var(--card)' }}>
          {TABS.map((t, i) => (
            <button key={i} onClick={() => setTab(i)} className={`tab${tab === i ? ' on' : ''}`}>
              {t}{counts[i] !== '' ? ` (${counts[i]})` : ''}
            </button>
          ))}
        </div>

        {/* Filters */}
        <div className="d-flex gap-2 p-3 flex-wrap" style={{ background: 'var(--surf)', borderBottom: '1px solid var(--brd2)' }}>
          <input
            className="finput flex-grow-1"
            style={{ minWidth: 230 }}
            placeholder="🔍  Search name, INN, molecule..."
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <select className="finput" style={{ width: 'auto' }}>
            <option>All Suppliers</option>
            {DB.suppliers.map(s => <option key={s.id}>{s.name}</option>)}
          </select>
          <select className="finput" style={{ width: 'auto' }}>
            <option>All Forms</option><option>Tablet</option><option>Injection</option><option>Infusion</option><option>Capsule</option>
          </select>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 30 }}><input type="checkbox" /></th>
                <th>Product</th>
                <th className="d-none d-md-table-cell">INN</th>
                <th className="d-none d-lg-table-cell">Type</th>
                <th className="d-none d-lg-table-cell">Form</th>
                <th className="d-none d-xl-table-cell">Strength</th>
                <th className="d-none d-xl-table-cell">Dossier</th>
                <th>NL</th>
                <th className="d-none d-md-table-cell">MA Status</th>
                <th className="d-none d-sm-table-cell">Supplier</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(p => (
                <tr key={p.id}>
                  <td><input type="checkbox" /></td>
                  <td>
                    <strong>{p.name}</strong>
                    {!p.nl && <div style={{ fontSize: 10, color: 'var(--amber)' }}>⚡ NL Gap</div>}
                  </td>
                  <td className="d-none d-md-table-cell" style={{ color: 'var(--t3)' }}>{p.inn}</td>
                  <td className="d-none d-lg-table-cell"><span className={`pill ${p.type === 'Combined' ? 'p-p' : 'p-t'}`}>{p.type}</span></td>
                  <td className="d-none d-lg-table-cell">{p.form}</td>
                  <td className="d-none d-xl-table-cell" style={{ fontFamily: "'DM Mono'", fontSize: 12 }}>{p.strength}</td>
                  <td className="d-none d-xl-table-cell"><span className="pill p-n">{p.dossier}</span></td>
                  <td><span className={`pill ${p.nl ? 'p-g' : 'p-r'}`}>{p.nl ? '✓' : '✗'}</span></td>
                  <td className="d-none d-md-table-cell"><span className={`pill ${maPill(p.ma)}`}>{p.ma}</span></td>
                  <td className="d-none d-sm-table-cell" style={{ fontSize: 12 }}>{p.supplier}</td>
                  <td><Link to="/bc/editor" className="btn btn-s btn-xs">BC →</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
